import "./styles.scss";

import React from "react";
import { Link } from "gatsby";

import { getColorVariant } from "utils";

import { navData } from "data/nav";

const Nav = () => {
  return (
    <nav className="header-mobile-nav">
      {navData.map((item, index) => (
        <Link key={index} className={getColorVariant(index + 1)} to={item.url}>
          {item.label}
        </Link>
      ))}
    </nav>
  );
};

export default Nav;
